import styled from 'styled-components'
import { animated } from 'react-spring'

import { Button } from 'components/button'
import { Icon } from 'components/icon'

export const TextContainer = styled(animated.div)`

  position: absolute;
  top: 100% !important;
  left: -80%;
  display: block;
  color: var(--font-color) !important;
  font-weight: var(--font-weight-regular);
  box-shadow: var(--depth-shadow-medium);
  font-size: var(--font-extra-small) !important;
  line-height: var(--line-large);
  background: var(--neutral-light);
  padding: var(--size-small);
  border: solid 1px var(--neutral-lighter);
  border-radius: var(--border-radius-medium);
  top: var(--size-extra-large);
  text-transform: none;
  z-index: 1;`


export const PendingDemandButton = styled(Button)`
  width: 100%;
  position: absolute;
  right 0;
  top: -14px;
  padding: var(--size-small) 12px;
  font-size: var(--font-small);
  width: unset;
  white-space: nowrap;
  cursor: default;
  z-index: 1;
  margin-top: 5px;

  :disabled {
    cursor: default;
  }
`

export const DemandWrap = styled.div`
    position: relative;
    height: fit-content;
`

export const DemandIcon = styled(Icon)`
    margin-right: var(--size-small);
`